import React, { useContext } from 'react';

import { MarketConfig } from 'data/market/types';
import { VerticalConfig } from 'utils/vertical';

interface ServerSideConstantsContextValue {
  isPlain: boolean;
  market: MarketConfig;
  verticalConfig: VerticalConfig;
}

interface PropsWithChildren {
  children: React.ReactNode;
}

type ConstantsProviderProps = ServerSideConstantsContextValue & PropsWithChildren;

const ServerSideConstantsContext = React.createContext<ServerSideConstantsContextValue | null>(null);

export const useServerSideConstants = (): ServerSideConstantsContextValue => {
  const constants = useContext(ServerSideConstantsContext);

  if (constants === null) {
    throw new ReferenceError('Server side constants are not being set properly');
  }

  return constants;
};

const ServerSideConstantsProvider = ({ children, ...value }: ConstantsProviderProps) => {
  return <ServerSideConstantsContext.Provider value={value}>{children}</ServerSideConstantsContext.Provider>;
};

export default ServerSideConstantsProvider;
